import { createContext, useContext } from "react";

export const LearningHabitContext = createContext();
export function useLearningHabitContext() {
	return useContext(LearningHabitContext);
}

export const LibraryContext = createContext();
export function useLibraryContext() {
	return useContext(LibraryContext);
}

export const UserContext = createContext(null);
export function useUserContext() {
	return useContext(UserContext);
}

export const QuickAccessContext = createContext();
export function useQuickAccessContext() {
	return useContext(QuickAccessContext);
}

export const UseZoomRoomContext = createContext();
export function useZoomRooomContext() {
	return useContext(UseZoomRoomContext);
}

export const LessonDetailsContext = createContext();
export function useLessonDetailsContext() {
	return useContext(LessonDetailsContext);
}

export const LayoutContext = createContext();
export function useLayoutContext() {
	return useContext(LayoutContext);
}

export const PermissionProviderContext = createContext();
export function usePermissionProviderContext() {
	return useContext(PermissionProviderContext);
}

export const QuizImageAttachmentPreviewContext = createContext();
export function useQuizImageAttachmentPreviewContext() {
	return useContext(QuizImageAttachmentPreviewContext);
}

export const FileHandlerProviderContext = createContext();
export function useFileHandlerProviderContext() {
	return useContext(FileHandlerProviderContext);
}
